interface HumanSupportMainProps {
  pageType: string;
}

const HumanSupportMain: React.FC<HumanSupportMainProps> = () => null;

HumanSupportMain.displayName = 'HumanSupportMain';

export default HumanSupportMain;
